import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const ORDER_SUBMTITED_TRACING_ACTIONS = {
  traceEditOrderButtonClick: createAction(
    '[NgRxTrace - Order] Edit Order Button Clicked on Order Details',
    props<{
      tracking: Tracking;
    }>(),
  ),

  submittedOrderDetails: createAction(
    '[NGRXTrace - Order] Submitted Order Details',
    props<{
      tracking: Tracking;
    }>(),
  ),
  downloadOrder: createAction(
    '[NGRXTrace - Order] Download Submitted Order Details',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
